<template>
  <div class="tree-wrapper">
    <el-collapse v-model="activeName" accordion class="tree-collapse">
      <el-collapse-item
        v-for="(item, index) in tree"
        :key="index"
        :title="item.name"
        :name="item.id"
      >
        <template slot="title">
          <i class="el-icon-caret-right el-collapse-item__arrow"></i
          >{{ item.name }}
        </template>
        <div
          class="tree-item-son pointer ell_one"
          v-for="(son, sonIndex) in item.childrenList"
          :key="sonIndex"
          :class="{ active: son.id === sonId }"
          @click="fetchList(item, son)"
        >
          {{ son.name }}
        </div>
        <div
          v-if="
            !item.childrenList ||
            (item.childrenList.length && item.childrenList.length === 0)
          "
          class="tree-item-son is-disabled"
        >
          <!-- <img src="@/assets/img/good/noGood.png" /> -->
          暂无数据
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: {
    tree: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data () {
    return {
      activeName: '',
      sonId: ''
    }
  },
  created () {},
  methods: {
    setActiveName (parentId, sonId) {
      this.activeName = parentId
      this.sonId = sonId
    },
    fetchList (parent, item) {
      this.activeName = parent.id
      this.sonId = item.id

      this.$emit('fetchList', parent, item.id)

      this.$router.replace({
        path: '/contentInfoList',
        query: {
          id: parent.id,
          treeId: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-wrapper {
  margin-top: 13px;
  width: 240px;
  border-radius: 13px;
  overflow: hidden;
  background: #f5f6fa;
  border: 2px solid #f5f6fa;

  .tree-collapse {
    border: none;
    min-height: 300px;

    /deep/ .el-collapse-item__header {
      padding: 0 16px;
      font-size: 14px;
      font-weight: bold;
      color: #2c2c2c;
      height: 44px;
      line-height: 44px;

      border-bottom: none;
      background: #f5f6fa;
      transition: background 0.3s, color 0.3s;
      transition-delay: 0;
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      .el-icon-caret-right {
        margin: 0 8px 0 0;
        color: rgba(44, 44, 44, 1);
      }

      .el-icon-arrow-right {
        display: none;
      }

      &.is-active {
        background: #ffffff;
        transition-delay: 0.1s;
        color: #2a54d1;

        .el-icon-caret-right {
          -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
        }
      }
    }

    /deep/ .el-collapse-item__wrap {
      border-bottom: none;
      background: #ffffff;

      .el-collapse-item__content {
        padding-bottom: 0;
      }

      .tree-item-son {
        padding: 12px 16px 12px 37px;
        font-size: 14px;
        line-height: 19px;
        color: #666666;
        border-top: 1px solid #f5f6fa;
        transition: background 0.3s, color 0.3s;

        &.is-disabled {
          cursor: default;
        }

        &.active {
          background: #2a54d1;
          color: #fff;
        }
      }
    }

    .el-collapse-item {
      border-radius: 12px;
      overflow: hidden;

      &.is-active {
        /deep/ .el-collapse-item__wrap {
          background: #ffffff;
        }
      }
    }
  }
}
</style>
